import type { ReactNode } from "react";

export const fieldLabelClassName =
  "text-xs font-medium uppercase tracking-wider text-neutral-500";

export function RequiredMark() {
  return <span className="text-whart-urgent"> *</span>;
}

type FieldLabelElement = "label" | "p" | "legend";

interface FieldLabelProps {
  children: ReactNode;
  /** When true, shows * — field is required to publish, not merely to save. */
  required?: boolean;
  htmlFor?: string;
  id?: string;
  as?: FieldLabelElement;
  className?: string;
}

export function FieldLabel({
  children,
  required = false,
  htmlFor,
  id,
  as: Component = "label",
  className = fieldLabelClassName,
}: FieldLabelProps) {
  const labelProps =
    Component === "label"
      ? { htmlFor, id, className }
      : { id, className };

  return (
    <Component {...labelProps}>
      {children}
      {required ? <RequiredMark /> : null}
    </Component>
  );
}
